<<template>
  <div class="salesmanmybonusPage">   
    <div class="xr-mingxi">      
      <mu-appbar class="xr-head" title="我的奖金">
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
        <router-link  slot="right" :to="'/salesman/mybonuslist?type='+activeTab">
            <p >明细</p>
        </router-link>
      </mu-appbar>
    </div>
   
    <mu-tabs :value="activeTab"   @change="handleTabChange">
      <mu-tab value="1" >零售奖金 </mu-tab>
      <mu-tab value="2" >推广奖金 </mu-tab>
      <mu-tab value="3" >批发奖金 </mu-tab>
    </mu-tabs>
     <div class="total balance" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
         <p class="title">奖金总数</p>
         <p class="money">{{awardInfo.TotalMoney.toFixed(2)}}</p>
    </div>
   
    <mu-list>
      <mu-list-item  title="">
        <mu-icon slot="left" value=":fa fa-calendar-check-o "/>
        <div class="mu-item-title" >已结算<span style=" color: #cccccc;">(笔)</span></div>
        <div class="mu-item-title" slot="right">{{awardInfo.JsCount}}</div>
      </mu-list-item>
      <mu-divider shallowInset/>
      <mu-list-item  title="">
        <mu-icon slot="left" value=":fa fa-calendar-times-o"/>
        <div class="mu-item-title" >未结算<span style=" color: #cccccc;">(笔)</span></div>
        <div class="mu-item-title" slot="right">{{awardInfo.UnJsCount}}</div>
      </mu-list-item>
      <mu-divider shallowInset/>
    </mu-list>
    <XR-toast ref="XRtoast"></XR-toast>
</div>
</template>
<script>
export default {
  data () {
    return {
      activeTab:'1',     
      awardInfo:{
      },
      siteConfig:{
        
      }
    }
  },
  mounted(){
    this.getSiteInfo()

    var tab = window.localStorage.SalesmanMyBonusActiveTab
    if(tab){
      this.activeTab = tab
    }
    this.getList()
  },
  methods: { 
    GoHistory(){
      this.$router.goBack()
    },
    handleTabChange (val) {
        this.activeTab = val

        window.localStorage.SalesmanMyBonusActiveTab = val

        this.getList()
    },
    getList(){
      var ths = this;   
      
      var url = '/Salesman/SalesmanServer/GetMyBonusTotal'      
      ths.$post(
        url, {type:this.activeTab}
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.awardInfo = {}
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
          ths.awardInfo =  res.Data
        }
      });
    },
    
    getSiteInfo: function () {    
      const ths = this;
      this.$post('/Shop/SiteConfigServer/GetSiteConfig')
        .then(function (res) {
          if(res.IsSuccess){
            ths.siteConfig = res.Data
          }         
        })
        .catch(function (err) {
          console.log(err)
        })    
    },   
  }
}
</script>
<style>
    .salesmanmybonusPage .text{
      font-size: 15px;
    }
    .salesmanmybonusPage .text a{
      color: #666666;
    }
    body .salesmanmybonusPage{
      background: #fff;
    }
    .salesmanmybonusPage .mu-item.show-left{
      padding-left: 50px;
    }
    .salesmanmybonusPage .xr-mingxi .mu-appbar.fixed{  
      padding:0;
      position: fixed;
      top:0;
      left: 0;
      }
    .salesmanmybonusPage .xr-mingxi .mu-appbar-title {
        font-size: 16px;
        }
    .salesmanmybonusPage .xr-mingxi .title .mu-icon-button {
        position: absolute;
        left: 0;
        top: 0;
        color:white;
        }
    .salesmanmybonusPage .xr-mingxi .title .title-text {
        margin: 0;
        line-height: 48px;
        }
    .salesmanmybonusPage .xr-mingxi .right{
        margin: 0 8px;
        font-size: 16px
    }
    .salesmanmybonusPage .xr-mingxi .right a{
        color: #fff;
    }
      .salesmanmybonusPage .total {
          padding: 20px;
          overflow: hidden;
          background: url("/static/us-top-bg.png");
          background-size: 100% 100%;
      }
      .salesmanmybonusPage .title {
          line-height: 24px;
          font-size: 14px;
          color: #fff;
      }
      .salesmanmybonusPage .money {
          font-size: 46px;
          color: red;
          line-height: 42px;
          padding: 10px 0;
          letter-spacing: -1px;
          color: #fff;
      }
      .salesmanmybonusPage .mu-tab-active{
            color:red;
          }
      .salesmanmybonusPage .mu-item-content{
        width: 80%;
      }
      .salesmanmybonusPage .mu-item-right {
          width: 20%;
          text-align: center;
      }
</style>



// WEBPACK FOOTER //
// src/pages/salesman/mybonus.vue